import React, { useState } from "react";
import { track } from "@vercel/analytics";
import "./ShareProgram.sass";

// Shares a public program URL via the device share sheet where supported,
// with Copy link as the fallback. Never includes registration details.
const copyText = async (text) => {
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
    return;
  }
  const textarea = document.createElement("textarea");
  textarea.value = text;
  textarea.setAttribute("readonly", "");
  textarea.style.position = "fixed";
  textarea.style.opacity = "0";
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand("copy");
  document.body.removeChild(textarea);
};

const ShareProgram = ({
  path,
  title,
  text,
  placement,
  eventName = "ic_share",
  label = "Share with a host or creator",
  className = "",
}) => {
  const [status, setStatus] = useState("");
  const canShare = typeof navigator !== "undefined" && typeof navigator.share === "function";
  const url = typeof window !== "undefined" ? `${window.location.origin}${path}` : path;

  const trackShare = (method) => {
    try {
      track(eventName, { method, placement });
    } catch (_) {}
  };

  const handleCopy = async () => {
    try {
      await copyText(url);
      setStatus("Link copied. Paste it anywhere to share.");
      trackShare("copy");
    } catch (_) {
      setStatus(`Copy this link: ${url}`);
    }
  };

  const handleShare = async () => {
    if (!canShare) return handleCopy();
    try {
      await navigator.share({ title, text, url });
      trackShare("native");
    } catch (err) {
      if (err?.name !== "AbortError") handleCopy();
    }
  };

  return (
    <div className={`share-program ${className}`.trim()}>
      <div className="share-program-actions">
        <button type="button" className="share-program-btn primary" onClick={handleShare}>
          {label}
        </button>
        {canShare && (
          <button type="button" className="share-program-btn link" onClick={handleCopy}>
            Copy link
          </button>
        )}
      </div>
      <p className="share-program-status" role="status" aria-live="polite">
        {status}
      </p>
    </div>
  );
};

export default ShareProgram;
